import { render, staticRenderFns } from "./MarkdownSelect.vue?vue&type=template&id=494c81b4&scoped=true"
import script from "./MarkdownSelect.vue?vue&type=script&lang=js"
export * from "./MarkdownSelect.vue?vue&type=script&lang=js"
import style0 from "./MarkdownSelect.vue?vue&type=style&index=0&id=494c81b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c81b4",
  null
  
)

export default component.exports